module.exports = __webpack_public_path__ + "img/Frame1877@2x.98958664.png";